import cornerstoneTools from 'cornerstone-tools';
import {textBoxWidth} from './ArrowAnnotateToolEyonix';
const AngleTool = cornerstoneTools.AngleTool;

const drawLinkedTextBox = cornerstoneTools.importInternal('drawing/drawLinkedTextBox');
const getNewContext = cornerstoneTools.import('drawing/getNewContext');
const draw = cornerstoneTools.import('drawing/draw');
const getPixelSpacing = cornerstoneTools.importInternal('util/getPixelSpacing');
const drawHandles = cornerstoneTools.import('drawing/drawHandles')
const setShadow = cornerstoneTools.importInternal('drawing/setShadow');
const drawJoinedLines = cornerstoneTools.import('drawing/drawJoinedLines');

export default class AngleToolEyonix extends AngleTool {
    constructor(props = {}) {
        super(props);
    }


    createNewMeasurement(eventData) {
        // Create the measurement data for this tool with the end handle activated
        return {
            visible: true,
            active: true,
            color: undefined,
            fontSize: undefined,
            textVisible: undefined,
            invalidated: true,
            who: undefined,
            when: undefined,
            whenStr: undefined,
            handles: {
                start: {
                    x: eventData.currentPoints.image.x,
                    y: eventData.currentPoints.image.y,
                    highlight: true,
                    active: false,
                },
                middle: {
                    x: eventData.currentPoints.image.x,
                    y: eventData.currentPoints.image.y,
                    highlight: true,
                    active: true,
                },
                end: {
                    x: eventData.currentPoints.image.x,
                    y: eventData.currentPoints.image.y,
                    highlight: true,
                    active: false,
                },
                textBox: {
                    active: false,
                    hasMoved: false,
                    movesIndependently: false,
                    drawnIndependently: true,
                    allowedOutsideImage: true,
                    hasBoundingBox: true,
                },
            },
        };
    }
    renderToolData(evt) {
        const eventData = evt.detail;
        const enabledElement = eventData.enabledElement;
        const {
            handleRadius,
            drawHandlesOnHover,
            hideHandlesIfMoving,
            renderDashed,
        } = this.configuration;
        // If we have no toolData for this element, return immediately as there is nothing to do
        const toolData = cornerstoneTools.getToolState(evt.currentTarget, this.name);
        const lineDash = cornerstoneTools.getModule('globalConfiguration').configuration.lineDash;

        if (!toolData) {
            return;
        }

        // We have tool data for this element - iterate over each one and draw it
        const context = getNewContext(eventData.canvasContext.canvas);
        const {image, element} = eventData;
        const {rowPixelSpacing, colPixelSpacing} = getPixelSpacing(image);

        const lineWidth = cornerstoneTools.toolStyle.getToolWidth();
       // const hideHandlers = eventData.viewport.hideHanders || false;

        function textBoxText(data, rowPixelSpacing, colPixelSpacing) {
            const suffix = !rowPixelSpacing || !colPixelSpacing ? ' (isotropic)' : '';
            const str = '00B0'; // Degrees symbol

            return (
                data.rAngle.toString() + String.fromCharCode(parseInt(str, 16)) + suffix
            );
        }

        function textBoxAnchorPoints(handles) {
            return [handles.start, handles.middle, handles.end];
        }

        for (let i = 0; i < toolData.data.length; i++) {
            const data = toolData.data[i];

            if (data.visible === false) {
                continue;
            }

            let initFontSize = cornerstoneTools.textStyle.getFontSize();

            draw(context, context => {
                setShadow(context, this.configuration);

                // Differentiate the color of activation tool
                var color = cornerstoneTools.toolColors.getColorIfActive(data);
                color = color.hasOwnProperty('main')? color['main']: color;


                data.color = data.color || cornerstoneTools.toolColors.getToolColor(data);


                data.fontSize = data.fontSize !== undefined? data.fontSize : cornerstoneTools.textStyle.getFontSize();
                data.textVisible = data.textVisible !== undefined? data.textVisible : this.options.annotationTextVisible;

                cornerstoneTools.textStyle.setFont(`${data.fontSize}px Roboto`);
                cornerstoneTools.textStyle.setFontSize(data.fontSize);

                if(data.invalidated && (data.who !== this.initialConfiguration.user || data.when !== new Date().toLocaleString())) {
                    data.who = this.initialConfiguration.user;
                    data.when = new Date().toLocaleString();
                    if(this.initialConfiguration.momentLib && this.initialConfiguration.defaultDateTimeFormat) {
                        data.whenStr = this.initialConfiguration.momentLib().format(this.initialConfiguration.defaultDateTimeFormat);
                    } else {
                        data.whenStr = new Date().toLocaleString();
                    }
                }

                const handleStartCanvas = window.cornerstone.pixelToCanvas(
                    eventData.element,
                    data.handles.start
                );
                const handleMiddleCanvas = window.cornerstone.pixelToCanvas(
                    eventData.element,
                    data.handles.middle
                );

                const lineOptions = {color};

                if (renderDashed) {
                    lineOptions.lineDash = lineDash;
                }

                drawJoinedLines(
                    context,
                    eventData.element,
                    data.handles.start,
                    [data.handles.middle, data.handles.end],
                    lineOptions
                );

                // Draw the handles
                const handleOptions = {
                    color,
                    handleRadius,
                    drawHandlesIfActive: drawHandlesOnHover,
                    hideHandlesIfMoving,
                };

                if (data.active) {
                    drawHandles(context, eventData, data.handles, handleOptions);
                }

                // Update textbox stats
                if (data.invalidated === true) {
                    if (data.rAngle) {
                        this.throttledUpdateCachedStats(image, element, data);
                    } else {
                        this.updateCachedStats(image, element, data);
                    }
                }

                const tooltipText =  `${data.who} (${data.whenStr})` ;

                if((data.active || this.options.showUser) && data.who) {
                    drawLinkedTextBox(
                        context,
                        element,
                        {
                            x: data.handles.end.x - (data.handles.end.x - data.handles.start.x)/2,
                            y: data.handles.end.y - (data.handles.end.y - data.handles.start.y)/2,
                        },
                        tooltipText,
                        data.handles,
                        textBoxAnchorPoints,
                        "white",
                        lineWidth,
                        0,
                        false
                    );
                }
                if (data.rAngle) {
                    const text = textBoxText(data, rowPixelSpacing, colPixelSpacing);

                    const distance = 15;

                    let textCoords;

                    if (!data.handles.textBox.hasMoved) {
                        textCoords = {
                            x: handleMiddleCanvas.x,
                            y: handleMiddleCanvas.y,
                        };

                        const padding = 5;
                        const textWidth = textBoxWidth(context, text, padding);

                        if (handleMiddleCanvas.x < handleStartCanvas.x) {
                            textCoords.x -= distance + textWidth + 10;
                        } else {
                            textCoords.x += distance;
                        }

                        const transform = window.cornerstone.internal.getTransform(
                            enabledElement
                        );

                        transform.invert();

                        const coords = transform.transformPoint(textCoords.x, textCoords.y);

                        data.handles.textBox.x = coords.x;
                        data.handles.textBox.y = coords.y;
                    }

                    if(data.textVisible) {
                        drawLinkedTextBox(
                            context,
                            eventData.element,
                            data.handles.textBox,
                            text,
                            data.handles,
                            textBoxAnchorPoints,
                            //color,
                            "white",
                            lineWidth,
                            0,
                            true
                        );
                    }
                }
            });
            cornerstoneTools.textStyle.setFontSize(initFontSize);
            cornerstoneTools.textStyle.setFont(`${initFontSize}px Roboto`);
        }
    }
}